import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { AppIdentifiers } from '../store/slices/token-state.slice';

export function useHasBusinessPlan(): boolean {
  const token = useSelector(
    (state: RootState) => state.tokenState[AppIdentifiers.App],
  );

  return useMemo(() => {
    try {
      if (!token?.accessToken || typeof token.accessToken !== 'string') {
        return false;
      }
      const payload = JSON.parse(atob(token.accessToken.split('.')[1]));
      const planLevel = payload?.planLevel;
      return planLevel === 'bus_std' || planLevel === 'bus_ann';
    } catch {
      return false;
    }
  }, [token?.accessToken]);
}
